<div class="cart-details__content">
  @if (!showNoResults) {
    <div class="cart-details">
      @if (!showIframeURL) {
        <div class="col-lg-12">
          <div class="cart-details__header">
            @if (!gs.isbookingCompleted) {
              <div>{{'MyActivitiesCart' | translate}}</div>
            }
            @if (gs.isbookingCompleted) {
              <div>{{'MyBookings' | translate}}</div>
            }
            @if (!gs.isbookingCompleted) {
              <div class="cart-details__amount-container">
                @if (gs.showTimer) {
                  <div class="cart-details__time-container">
                    <div class="focused-sub-header  cart-details__time-mins"
                      [ngStyle]="gs.minutes === 0 && gs.seconds < 60 ?  {'color':'#B00020'} : {'color':'#635D7B'}">
                      <span class="cart-details__timer-number">{{gs.minutes}}</span>
                      <span class="error-message">{{'mins' | translate}}</span> <span
                    class="cart-details__timer-number">{{gs.seconds}}</span> <span
                    class="error-message">{{'secs'
                    |
                  translate}}</span>
                </div>
                <div class="cart-details__time-left-text">{{'leftForBooking' | translate}}</div>
              </div>
            }
            <div class="cart-details__time-container">
              <span>{{'TotalPayable' | translate}}</span> <span>{{' '}}</span>{{':'}}<span>{{' '}}</span>
              <span>{{OperationCurrency}}{{ TotalCartValue | currencyDecimalFormatter}}</span>
            </div>
          </div>
        }
      </div>
      <div class="cart-details__container">
        @for (party of CartList; track party; let i = $index) {
          <div class="cart-details__container--card">
            @if (!gs.isbookingCompleted || party.SlotLockResult) {
              <mat-card class="cart-details__container__card-details"
                >
                <div class="cart-details__img-container">
                  @if (party.bannerImage) {
                    <section class="class-info__image"
                      [style.background-image]="'url(data:image/png;base64,'+ party.bannerImage +')'">
                    </section>
                  }
                  @if (!party.bannerImage) {
                    <section class="class-info__image"
                      [style.background-image]="'url(assets/images/defaultImage.png)'">
                    </section>
                  }
                </div>
                <mat-card class="cart-details__container__card">
                  <div class="cart-details__container__card-container"
                    [ngStyle]="!party.SlotLockResult ? {'opacity' : '0.4'} : {'opacity' : '1'} ">
                    <div class="cart-details__container__card--lessonName text-overflow">
                      {{party.ActivityName ? party.ActivityName : party.SelectedActivity?.LessonName}}
                    </div>
                    @if ((party.StaffsList && party.StaffsList.length)) {
                      <div class="cart-details__container__card--StaffName text-overflow"
                        >{{'By' | translate}}
                        <span>{{party.StaffsList[0]}}</span>@if (party.StaffsList.length > 1) {
                        <span title="{{party.Staffs}}"
                        >+{{party.StaffsList.length - 1}}</span>
                      }
                    </div>
                  }
                  @if (!(party.StaffsList && party.StaffsList.length) && party.SpecialMealId && party.SelectedActivity?.Staffs ) {
                    <div class="cart-details__container__card--StaffName text-overflow"
                      >{{'By'|translate}}
                      <span>{{party.SelectedActivity.Staffs}}</span>
                    </div>
                  }
                  @if (party.TableList && party.TableList.length) {
                    <div class="cart-details__container__card--LocName">
                      <mat-icon class="location_on" aria-hidden="false" aria-label="location">location_on
                      </mat-icon>
                      @if (party.TableList && party.TableList.length) {
                        <span class="cart-details__container__itemName"
                          >
                          {{party.TableList[0]}}
                        </span>
                      }
                      @if (party.TableList && party.TableList.length > 1) {
                        <span title="{{party.TableNames}}"
                          >+{{party.TableList.length
                          - 1}}
                        </span>
                      }
                      {{' '}}|{{' '}}<span
                    class="cart-details__container__itemName">{{party.Size}}</span>{{' '}}
                    <mat-icon class="person" aria-hidden="false" aria-label="location">person</mat-icon>
                  </div>
                }
                @if (!(party.TableList && party.TableList.length) && party.SelectedActivity?.LocationName) {
                  <div class="cart-details__container__card--LocName">
                    <mat-icon class="location_on" aria-hidden="false" aria-label="location">location_on
                    </mat-icon>
                    @if (!(party.TableList && party.TableList.length) && party.SelectedActivity?.LocationName) {
                      <span class="cart-details__container__itemName"
                        >
                        {{party.SelectedActivity.LocationName}}
                      </span>
                    }
                    {{' '}}|{{' '}}<span
                  class="cart-details__container__itemName">{{party.Size}}</span>{{' '}}
                  <mat-icon class="person" aria-hidden="false" aria-label="location">person</mat-icon>
                </div>
              }
            </div>
          </mat-card>
          <div class="cart-details__container__empty-div cart-details___margin"></div>
          <div class="cart-details__container__wrapper"
            [ngStyle]="!party.SlotLockResult ? {'opacity' : '0.4'} : {'opacity' : '1'} ">
            @if (party.Id) {
              <div class="cart-details__container__date-container cart-details___margin">
                {{party.StartDate | localizeDate:'DD MMM YYYY'}} {{' To '}} {{party.EndDate | localizeDate: 'DD MMM
                YYYY'}}
              </div>
            }
            @if (!party.Id) {
              <div class="cart-details__container__date-container cart-details___margin"
                >
                {{'On' | translate}} {{' '}} {{party.StartDate | localizeDate:'DD MMM YYYY'}}
              </div>
            }
            <div class="cart-details__container__charge-container">
              <div class="cart-details__container__charge">
                <div class="cart-details__container__charge--row">
                  <span class="text-overflow">{{'SessionCharge' | translate}}</span>
                  @if (party.RatePlan?.TotalRatePlan) {
                    <span class="cart-details__container__charge--value"
                      >{{OperationCurrency}}{{'
                    '}}{{party.RatePlan?.TotalRatePlan | currencyDecimalFormatter}}</span>
                  }
                  @if (!party.RatePlan?.TotalRatePlan) {
                    <span class="cart-details__container__charge--value"
                      >{{OperationCurrency}}{{'
                    '}}{{ 0 | currencyDecimalFormatter}}</span>
                  }
                </div>
              </div>
            </div>
            <div class="cart-details__container__charge-container">
              @if (!party.RatePlan?.TotalDepositAmount) {
                <div class="cart-details__container__charge--row"
                  >
                  <span class="cart-details__container__charge--value">{{'total'| translate}}</span>
                  @if (party.RatePlan?.TotalRatePlan) {
                    <span class="cart-details__container__charge--value"
                      >{{OperationCurrency}}{{'
                    '}}{{party.RatePlan?.TotalRatePlan | currencyDecimalFormatter}}</span>
                  }
                  @if (!party.RatePlan?.TotalRatePlan) {
                    <span class="cart-details__container__charge--value"
                      >{{OperationCurrency}}{{'
                    '}}{{ 0 | currencyDecimalFormatter}}</span>
                  }
                </div>
              }
              @if (party.RatePlan?.TotalDepositAmount) {
                <div class="cart-details__container__charge--row"
                  >
                  <span class="cart-details__container__charge--value">{{'Deposit'| translate}}</span>
                  <span class="cart-details__container__charge--value">{{OperationCurrency}}{{'
                  '}}{{party.RatePlan?.TotalDepositAmount| currencyDecimalFormatter}}</span>
                </div>
              }
            </div>
          </div>
          <div class="cart-details__container__actions">
            @if (party.SlotLockResult && !gs.isbookingCompleted) {
              <div class="cart-details__container__actions--button"
                (click)="editItem(party, i)">
                <mat-icon class="mat-icon cursor-pointer" [matTooltip]="'Edit' | translate"
                  matTooltipPosition="above" aria-hidden="false" aria-label="Edit">
                edit</mat-icon>
                <span class="cursor-pointer">{{'edit' | translate}}</span>
              </div>
            }
            <span>{{' '}}</span>
            @if (!gs.isbookingCompleted) {
              <div class="cart-details__container__actions--button" (click)="removeItem(party, i)"
                >
                <mat-icon class="mat-icon cursor-pointer" [matTooltip]="'Delete' | translate"
                matTooltipPosition="above" aria-hidden="false" aria-label="Delete">delete</mat-icon>
                <span class="cursor-pointer">{{'remove' | translate}}</span>
              </div>
            }
            @if (gs.isbookingCompleted) {
              <div class="cart-details__container__actions--button cart-details__container__actions--View-btn"
                (click)="viewPartySummary(party)">
                {{'ViewSummary' | translate}}
              </div>
            }
          </div>
        </mat-card>
      }
    </div>
  }
</div>
</div>
}
@if (showIframeURL) {
  <div class="col-lg-9 Iframe-container" [ngClass]="showIframeLoader ? 'Iframe-loader' :''">
    <iframe title="" class="Iframe-container__margin" width="560px" height="560px" [src]="IframeURL"></iframe>
  </div>
}
@if (showIframeURL) {
  <div class="col-lg-3 payment-container">
    @if (gs.showTimer) {
      <div class="cart-details__time-container">
        <div class="cart-details__header">
          <div class="focused-sub-header  cart-details__time-mins"
            [ngStyle]="gs.minutes === 0 && gs.seconds < 60 ?  {'color':'#B00020'} : {'color':'#635D7B'}">
            <span class="cart-details__timer-number">{{gs.minutes}}</span>
            <span class="error-message">{{'mins' | translate}}</span> <span
          class="cart-details__timer-number">{{gs.seconds}}</span> <span
          class="error-message">{{'secs'
          |
        translate}}</span>
      </div>
      <div class="cart-details__time-left-text pt-3">{{'leftForBooking' | translate}}</div>
    </div>
  </div>
}
<div class="payment-container__header">
  {{'PaymentSummary' | translate}}
</div>
<div class="payment-container__charge-container">
  <div class="cart-details__container__charge">
    <div class="cart-details__container__charge--row">
      <span>{{'SubTotal' | translate}}</span>
      <span class="cart-details__container__charge--value">{{OperationCurrency}}{{'
      '}}{{TotalCartValue | currencyDecimalFormatter}}</span>
    </div>
    <!-- <div class="cart-details__container__charge--row">
    <span>{{'MembershipDiscount' | translate}}</span>
    <span class="cart-details__container__charge--value">{{OperationCurrency}}{{'
    '}}{{TotalMembershipDiscount | currencyDecimalFormatter}}</span>
  </div>
  <div class="cart-details__container__charge--row">
    <span>{{'DepositAmount' | translate}}</span>
    <span class="cart-details__container__charge--value">{{OperationCurrency}}{{'
    '}}{{TotalDepositAmount | currencyDecimalFormatter}}</span>
  </div> -->
</div>
</div>
<div class="cart-details__container__charge-container">
  <div class="cart-details__container__charge--row">
    <span class="cart-details__container__charge--value">{{'TotalPayable'| translate}}</span>
    <span class="cart-details__container__charge--value">{{OperationCurrency}}{{'
    '}}{{TotalCartPayment | currencyDecimalFormatter}}</span>
  </div>
</div>
<div class="payment-container__action-button">
  <app-button [buttontype]="backToSummaryBtn" class="payment-container__button"
    (valueChange)="backtosummaryBooking()">
  </app-button>
  <app-button [buttontype]="cancelBookingBtn" class="payment-container__button"
    (valueChange)="backtosummaryBooking()">
  </app-button>
</div>
</div>
}
</div>
}

@if (!showIframeURL) {
  <div class="payment-container__payment-action-btn">
    @if (!gs.isbookingCompleted && !showNoResults) {
      <app-button [buttontype]="proceedBtn" class="payment-container__button"
        (valueChange)="proceedBooking()">
      </app-button>
    }
    @if (!gs.isbookingCompleted && !showNoResults) {
      <app-button [buttontype]="cancelBtn" class="payment-container__button"
        (valueChange)="cancelBooking()">
      </app-button>
    }
    <app-button [buttontype]="continueBtn" class="payment-container__button" (valueChange)="continueBooking()">
    </app-button>
  </div>
}

@if (showNoResults) {
  <div>
    <div class="cart-details__empty-cart"> {{'YourCartisEmpty' | translate}}
    </div>
  </div>
}
</div>